import { useLocation, useNavigate } from "react-router-dom";
import { ColumnsType } from "antd/es/table";
import Footer from "../../../core/common/Footer";
import Datatable from "../../../core/common/dataTable";
import { cellWidth } from "../../../core/methods/tableCellWidth";

const OrganisationDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const user = location.state?.user;

  const accounts: string[] = Array.isArray(user?.project_name)
    ? user.project_name
    : user?.project_name
      ? [user.project_name]
      : [];

  const programs: string[] = Array.isArray(user?.program_name)
    ? user.program_name
    : user?.program_name
      ? [user.program_name]
      : [];

  const departments: string[] = Array.isArray(user?.department_name)
    ? user.department_name
    : user?.department_name
      ? [user.department_name]
      : [];

  const renderItems = (items: string[]) => {
    if (!items.length) {
      return <span className="text-muted">No data available</span>;
    }

    return (
      <div className="d-flex flex-wrap gap-2">
        {items.map((item, index) => (
          <span
            key={`${item}-${index}`}
            className="badge rounded-pill"
            style={{
              background: "#EEF4FF",
              color: "#0D6EFD",
              border: "1px solid #CFE2FF",
              padding: "8px 12px",
              fontWeight: 500,
            }}
          >
            {item}
          </span>
        ))}
      </div>
    );
  };
 
  const tableData = [
    {
      key: "organisation-details",
      account: accounts,
      program: programs,
      department: departments,
    },
  ];

  const columns: ColumnsType<any> = [
    {
      title: "Account",
      dataIndex: "account",
      key: "account",
      render: (items: string[]) => renderItems(items),
    },
    {
      title: "Program",
      dataIndex: "program",
      key: "program",
      render: (items: string[]) => renderItems(items),
    },
    {
      title: "Department",
      dataIndex: "department",
      key: "department",
      onCell: () => cellWidth(500), 
      render: (items: string[]) => renderItems(items),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header d-flex justify-content-between align-items-center">
          <div>
            <h3 className="page-title">User Details</h3>

            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <span
                  role="link"
                  tabIndex={0}
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate(-1)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") navigate(-1);
                  }}
                >
                  Manage Users
                </span>
              </li>
              <li className="breadcrumb-item active">Organisation</li>
            </ul>
          </div>

          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={() => navigate(-1)}
          >
            Back
          </button>
        </div>

        {!user ? (
          <div className="alert alert-warning">
            User details are not available. Please open this page by clicking a
            username from Manage Users.
          </div>
        ) : (
          <>
            <div className="card mb-3">
              <div className="card-body">
                <h5 className="fw-bold mb-3">User Information</h5>

                <div className="row g-3">
                  <div className="col-md-4">
                    <strong>Username</strong>
                    <p className="mb-0">{user.name || "--"}</p>
                  </div>

                  <div className="col-md-4">
                    <strong>Email</strong>
                    <p className="mb-0">{user.email || "--"}</p>
                  </div>

                  <div className="col-md-4">
                    <strong>Phone</strong>
                    <p className="mb-0">{user.mobile || "--"}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="card mt-3">
              <Datatable
                columns={columns}
                dataSource={tableData}
                rowKey="key"
                Selection={false}
                fixedHeader
                tableHeight={650}
              />
            </div>
          </>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default OrganisationDetails;

// import { useLocation, useNavigate } from "react-router-dom";
// import Footer from "../../../core/common/Footer";

// const OrganisationDetails = () => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const user = location.state?.user;

//   console.log("user =>", user)

//   const accounts: string[] = user?.project_name || [];
//   const programs: string[] = user?.program_name || [];
//   const departments: string[] = user?.department_name || [];

//   const renderItems = (items: string[]) => {
//     if (!items.length) {
//       return <span className="text-muted">No data available</span>;
//     }

//     return (
//       <div className="d-flex flex-wrap gap-2">
//         {items.map((item, index) => (
//           <span
//             key={`${item}-${index}`}
//             className="badge rounded-pill"
//             style={{
//               background: "#EEF4FF",
//               color: "#0D6EFD",
//               border: "1px solid #CFE2FF",
//               padding: "8px 12px",
//               fontWeight: 500,
//             }}
//           >
//             {item}
//           </span>
//         ))}
//       </div>
//     );
//   };

//   return (
//     <div className="page-wrapper">
//       <div className="content">
//         <div className="page-header d-flex justify-content-between align-items-center">
//           <div>
//             <h3 className="page-title">User Details</h3>

//             <ul className="breadcrumb">
//               <li className="breadcrumb-item">
//                 <span
//                   role="link"
//                   tabIndex={0}
//                   style={{ cursor: "pointer" }}
//                   onClick={() => navigate(-1)}
//                   onKeyDown={(e) => {
//                     if (e.key === "Enter") navigate(-1);
//                   }}
//                 >
//                   Manage Users
//                 </span>
//               </li>
//               <li className="breadcrumb-item active">
//                 Organisation
//               </li>
//             </ul>
//           </div>

//           <button
//             type="button"
//             className="btn btn-outline-secondary"
//             onClick={() => navigate(-1)}
//           >
//             Back
//           </button>
//         </div>

//         {!user ? (
//           <div className="alert alert-warning">
//             User details are not available. Please open this page by
//             clicking a username from Manage Users.
//           </div>
//         ) : (
//           <>
//             <div className="card mb-3">
//               <div className="card-body">
//                 <h5 className="fw-bold mb-3">User Information</h5>

//                 <div className="row g-3">
//                   <div className="col-md-4">
//                     <strong>Username</strong>
//                     <p className="mb-0">{user.name || "--"}</p>
//                   </div>

//                   <div className="col-md-4">
//                     <strong>Email</strong>
//                     <p className="mb-0">{user.email || "--"}</p>
//                   </div>

//                   <div className="col-md-4">
//                     <strong>Phone</strong>
//                     <p className="mb-0">{user.mobile || "--"}</p>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="card mb-3">
//               <div className="card-body">
//                 <h5 className="fw-bold mb-3">Account</h5>
//                 {renderItems(accounts)}
//               </div>
//             </div>

//             <div className="card mb-3">
//               <div className="card-body">
//                 <h5 className="fw-bold mb-3">Program</h5>
//                 {renderItems(programs)}
//               </div>
//             </div>

//             <div className="card mb-3">
//               <div className="card-body">
//                 <h5 className="fw-bold mb-3">Department</h5>
//                 {renderItems(departments)}
//               </div>
//             </div>
//           </>
//         )}
//       </div>

//       <Footer />
//     </div>
//   );
// };

// export default OrganisationDetails;
